import styled from 'styled-components';
import { gray45, gray60, spacer12 } from '@spotify-internal/encore-foundation';
import { typeStyleBody2 } from "../../styles";
export default styled.span.withConfig({
  displayName: "Label",
  componentId: "sc-1utc215-0"
})(["", ";color:", ";padding-right:", ";"], typeStyleBody2(), function (props) {
  return props.theme.paginationControls === 'dark' ? gray60 : gray45;
}, spacer12);